import React from "react";
import {
  Autocomplete,
  FormControlLabel,
  FormHelperText,
  Switch,
  TextField,
} from "@mui/material";
import { FormikProps } from "formik";
import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "src/utilities";
import { useAuth } from "src/context/auth";
import { IFollowUpGroups } from "src/interface/IFollowUpGroups";
import { IService } from "src/interface/IService";

// ساخت schema برای اعتبارسنجی با yup

const FollowUpGroupForm = ({ formik }: { formik: FormikProps<any> }) => {
  const { user } = useAuth();

  const { data: Services, isLoading: serviceLoading } = useQuery({
    queryKey: ["ServicesData"],
    queryFn: () =>
      fetch(API_URL + "services", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });

  const [getServices, setServices] = React.useState<IService[]>([]);
  React.useEffect(() => {
    if (Services) {
      setServices(
        Services.map((item: IService) => ({
          label: item.name,
          value: item.id,
        }))
      );
    }
  }, [Services]);

  return (
    <>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={5}>
          <Autocomplete
            value={getServices.find(
              //@ts-ignore
              (s) => s.value === formik.values.serviceRef
            )}
            onChange={(event: any, newValue: any) => {
              formik.setFieldValue("serviceRef", newValue?.value || undefined);
            }}
            loading={serviceLoading}
            options={getServices}
            fullWidth
            renderInput={(params) => (
              <TextField
                error={
                  formik.touched.serviceRef && Boolean(formik.errors.serviceRef)
                }
                helperText={
                  (formik.touched.serviceRef &&
                    formik.errors.serviceRef) as boolean
                }
                {...params}
                label="خدمت"
                placeholder="خدمت"
              />
            )}
          />
        </Grid2>
        <Grid2 size={2}>
          <TextField
            {...formik.getFieldProps("priority")} // استفاده از ویژگی‌های فرمیک
            label="اولویت"
            placeholder="اولویت"
            type="number"
            error={formik.touched.priority && Boolean(formik.errors.priority)}
            helperText={
              (formik.touched.priority && formik.errors.priority) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
        <Grid2 size={5}>
          <TextField
            {...formik.getFieldProps("title")} // استفاده از ویژگی‌های فرمیک
            label="عنوان گروه"
            placeholder="عنوان گروه"
            error={formik.touched.title && Boolean(formik.errors.title)}
            helperText={
              (formik.touched.title && formik.errors.title) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>
      <FormControlLabel
        control={
          <Switch
            checked={formik.values.isSendSMS}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              formik.setFieldValue("isSendSMS", event.target.checked);
            }}
          />
        }
        label="پیامک"
      />
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={12}>
          <FormHelperText>
            برای جای گذاری اسم مشتری در متن پیامک از "customer_name" استفاده
            کنید
          </FormHelperText>
          <TextField
            style={{ marginTop: 10 }}
            multiline
            rows={4}
            {...formik.getFieldProps("sampleSMSPayment")} // استفاده از ویژگی‌های فرمیک
            label="نمونه پیامک"
            placeholder="نمونه پیامک"
            error={
              formik.touched.sampleSMSPayment &&
              Boolean(formik.errors.sampleSMSPayment)
            }
            helperText={
              (formik.touched.sampleSMSPayment &&
                formik.errors.sampleSMSPayment) as boolean
            }
            variant="outlined"
            fullWidth
            inputProps={{
              style: {
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              },
            }}
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default FollowUpGroupForm;
